export default __webpack_public_path__ + "static/media/favorite_heart.1f7366b0.gif";